import styled from 'styled-components';

import { RegularSm } from 'modules/ui/typography';
import { Colors } from 'modules/ui/theme/colors';

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const InfoLabel = styled(RegularSm)`
  color: ${Colors.SolidGray};
`;

export const InfoValue = styled(RegularSm)`
  color: ${Colors.Black};
`;

export const ActionsRow = styled.div`
  margin-top: 12px;
`;
